<template>
	<span class="user-column" v-if="value">

		<a v-if="hrefTarget"
		   :href="hrefTarget"
		   target="_blank"
		>
			<img :src="firstImage" class="img-prop-thumb-table" data-toggle="m-tooltip"  data-original-title="Click to View property">
		</a>

		<img v-else :src="firstImage" class="img-prop-thumb-table" data-toggle="m-tooltip"  data-original-title="Property not Active">

	</span>
</template>
<style>
    .img-prop-thumb-table{
		width: 71px !important;
		height: 47px !important;
    }
</style>
<script>
    export default {
        props: ['value'],
        computed: {
            firstImage() {
                return this.value.firstImage && this.value.firstImage.sizes && this.value.firstImage.sizes.thumb;
            },
			hrefTarget () {
                if(this.value.slug[this.$lang.current]){
                	return `${this.$lang.current == 'sr' ? 'sr/nekretnina' :'property'}/${this.value.slug[this.$lang.current] }`;
				}
				return null;
            }
        },
	}

</script>


// WEBPACK FOOTER //
// resources/js/metronic/table/value/panel/PropertyImage.vue